import React, { Fragment, useEffect, useState } from 'react';
import { Trans } from '@common/i18n/trans';
import { useFormContext } from 'react-hook-form';
import { Button } from '@common/ui/buttons/button';
import { useTrans } from '@common/i18n/use-trans';
import { DialogTrigger } from '@common/ui/overlays/dialog/dialog-trigger';
import { UploadDialog } from './loan-program-upload';
import { downloadFile } from '@app_modules/document-requests/reports/requests/use-download-bsa-report';
import { DownloadIcon } from '@common/icons/material/Download';
import { useAuth } from '@common/auth/use-auth';
import { ViewResult } from './uw-view-result';
import { ViewOriginal } from '@app_modules/document-requests/reports/document-report-documents-sideleft';
import { useDownloadMdLoanProgram } from './requests/use-download-md-loan-program';

interface RowUwProps {
  id: string|number;
  loan_product: any;
  meta_hader: string;
  item: any;
  subItems: any[];
  pidx: number;
  uploadFileItem: (fileItem: any) => void;
}

export function RowLoanProgram({
  id,
  loan_product,
  meta_hader,
  item,
  pidx,
  uploadFileItem,
}: RowUwProps) {
  const {user} = useAuth();
  const user_id = user?.id;

  const { trans } = useTrans();
  const { watch } = useFormContext<any>();
  const [fileItem, setFileItem] = useState<any>(item.files ? item.files : []);
  const loan_product_id = loan_product.id;

  const addFiles = (pidx: number, files: File[]) => {
      setFileItem(files[0]);
      uploadFileItem(files[0]);
  };
  useEffect(() => {
    setFileItem(fileItem);
  }, [fileItem]);


  const onProcess = (status: string, total_files: number, uploaded_date: string, file_name: string) => {
    if (total_files) {
      // setFileItem({ status, total_files, uploaded_date, file_name });
      // setFileItem([]);
    }
  };

  const [metaHeader, setMetaHeader] = useState('');
  useEffect(() => {
    if (meta_hader) {
      setMetaHeader(meta_hader);
    }
  }, [meta_hader]);

  const downloadMd = useDownloadMdLoanProgram();

  return (
    <tr key={`meta-${pidx}`} className="border-b transition duration-300 ease-in-out hover:bg-gray-100 w-[100%]">
      <td
        className="text-wrap pl-40 w-[10%] text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap border-r"
        colSpan={2}
        rowSpan={fileItem.length || 1}
      >
        <Fragment>
          <DialogTrigger type="modal">
            <Button size="xs" variant="outline" color="orange" className="mr-10">
              <Trans message="Upload" />
            </Button>
            <UploadDialog pidx={pidx} addFiles={addFiles} />
          </DialogTrigger>
          {fileItem.name || fileItem.filename ? (<>
            {fileItem.name ? fileItem.name : fileItem.filename}
            {fileItem.file_id && (user_id == 1 || user_id == 35) ? (<>
              <ViewOriginal file_id={fileItem.file_id} />
            </>):(<></>)}
          </>):(<></>)}
        </Fragment>
      </td>
      <td className="w-[10%] text-sm text-gray-900 px-6 py-4 whitespace-nowrap" colSpan={2}>
          {item.status}
      </td>
      <td>
      {item.status == 'Completed' && (user_id == 1 || user_id == 35) ? (
        <Button
          variant="outline"
          color="primary"
          size={'2xs'}
          onClick={() => {
            downloadMd.mutate({id: id}, {
              onSuccess: (response: any) => {
                const file_name = item.id;
                downloadFile(file_name+'.md', response)
              },
            });
          }}
        >
          Raw File <DownloadIcon/>
        </Button>) : (<></>)}

        {item.status == 'Completed' ? (<>
          <ViewResult key={`result-${pidx}`} item={item} pindex={pidx}/>
        </>) : (<>
        </>)}
      </td>
    </tr>
  );
}